import * as Yup from "yup";
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

const QuestionValidation = Yup.object({
    question: Yup.string().required("Question is Required"),
    answer: Yup.string().required("Answer is Required"),
    attachment: Yup.mixed().when("id", {
        is: (id) => !id,
        then: Yup.mixed()
          .nullable()
          .test("fileSize", "File size is too big", (value) => {
              if (!value) return true; // If no file, it's valid
              return value.size <= 5 * 1024 * 1024; // 5MB limit
          })
          .test("fileType", "Invalid image format, must be jpg, png, or jpeg", (value) => {
              if (!value) return true; // If no file, it's valid
              return SUPPORTED_FORMATS.includes(value.type);
          }),
    }),

    option1: Yup.string().required("Option1 is Required"),
    option2: Yup.string().required("Option2 is Required"),

    questionCategoriesId: Yup.string().required("Question Category is Required"),
});

export default QuestionValidation;